export type ColumnConfig = {
  value: string
  span: number
}

export function generateDropColumnHeaders(showWaterReading: boolean, formattedUnit: string): ColumnConfig[] {
  let columns: ColumnConfig[] = [
    { value: 'SITE', span: 3 },
    { value: 'PRODUCT', span: 3 },
    { value: 'TANK', span: 3 },
    { value: 'DATE', span: 3 },
    { value: 'TIME', span: 2 },
    { value: 'START READING', span: showWaterReading ? 2 : 3 },
    { value: 'END READING', span: showWaterReading ? 2 : 3 },
    { value: `QTY (${formattedUnit})`, span: showWaterReading ? 2 : 3 },
  ]
  // add water reading column if tank has water reading required or optional
  if (showWaterReading) {
    columns = [...columns.slice(0, 6), { value: 'WATER READING', span: 2 }, ...columns.slice(6)]
  }

  return columns
}

export function generateBolColumnHeaders(formattedUnit: string, isBackhaul: boolean): ColumnConfig[] {
  const cols: ColumnConfig[] = [
    { value: 'SUPPLIER', span: 4 },
    { value: 'PRODUCT', span: 4 },
    { value: 'CONTRACT', span: 3 },
    { value: `GROSS QTY (${formattedUnit})`, span: 3 },
    { value: `NET QTY (${formattedUnit})`, span: 3 },
    { value: 'POCKET', span: isBackhaul ? 4 : 3 },
  ]

  // add price type column if not backhaul order
  if (!isBackhaul) {
    cols.splice(6, 0, { value: 'PRICE TYPE', span: 1 })
  }

  return cols
}
